import Vue from "vue";

const STORAGE_KEY = "kiPilotTheorieUnlocked";
const REQUIRED_PRESSES = 5;
const RESET_AFTER_MS = 2000;

export const KI_PILOT_THEORIE_PATH = "/ki-pilot-theorie";

export const kiPilotTheorieUnlockState = Vue.observable({
  unlocked: localStorage.getItem(STORAGE_KEY) === "true",
});

let escPressCount = 0;
let lastEscPressAt = 0;

function handleKeydown(event: KeyboardEvent): void {
  if (event.key !== "Escape") return;

  const now = Date.now();
  if (now - lastEscPressAt > RESET_AFTER_MS) {
    escPressCount = 0;
  }
  lastEscPressAt = now;
  escPressCount += 1;

  if (escPressCount >= REQUIRED_PRESSES) {
    kiPilotTheorieUnlockState.unlocked = true;
    localStorage.setItem(STORAGE_KEY, "true");
    window.removeEventListener("keydown", handleKeydown);
  }
}

export function initKiPilotTheorieUnlockListener(): void {
  if (kiPilotTheorieUnlockState.unlocked) return;
  window.addEventListener("keydown", handleKeydown);
}
